import { Comment } from '../_model/comment/comment';
import { Injectable } from "@angular/core";
import { Resource } from 'app/_service/resource/resource';

@Injectable()
export class CommentTransFormer {
    fromList(item, isNews = false) {

        const comment: Comment = {
            commendId: isNews ? item.comment.id : item.id,
            floor: item.louCeng,
            likes: item.likes || item.comment?.hit || 0,
            content: item.context,
            author: isNews ? item.comment.nickName : item.nickName,
            authorId: isNews ? item.comment.uid : item.uid,
            avatar: item.headImage,
            videoId: isNews ? item.comment.vid : item.videoID,
            replyId: item.replyID,
            replyUserId: item.replyUID,
            replyNikcName: item.replyNickName,
            replyUserLevel: item.replyUserLevel,
            replyUserKey: item.replyUserKey,
            rawContext: item.rawContext,
            replyFloor: item.replyLouCeng,
            userLevelSymbol: isNews ? Resource.getGIDResource(item.comment.gid) : Resource.getGIDResource(item.gid),
            isOfficalUP: item.isOfficalUP ? item.isOfficalUP : item.comment ? item.comment.isOfficalUP : false,
            published: item.post_Date || "刚刚",
            liked: !!item.isLike ? item.isLike : false,
            deleted: item.isDeleted > 0,
            blacklist: item.isDeleted === 3,
            pollId: item.voteId,
            status: item.userStatus,
            children: !!item.children ? item.children.map(p => this.fromList(p, isNews)) : [],
            level: item.userLevel || 1,
            totalReplies: item.childrenCount,
            userKey:item.userKey,
            gid: isNews ? item.comment.gid : item.gid,
        };
        return comment;
    }

    fromGetCommentById(item) {
        const comment: Comment = {
            level: item.level || 1,
            commendId: '',
            floor: item.louCeng,
            likes: '',
            content: item.context, //
            author: item.nickName, //
            authorId: item.uid,
            avatar: item.headImage, //
            videoId: 0,
            replyId: item.replyID,
            replyUserId: item.replyUID,
            replyNikcName: item.replyNickName,
            replyUserLevel: item.replyUserLevel,
            replyUserKey: item.replyUserKey,
            rawContext: item.rawContext,
            replyFloor: item.replyLouCeng,
            userLevelSymbol: item.userLevelPic.replace('assets/images/', '/assets/images/membership/'),
            isOfficalUP: item.isOfficalUP ? item.isOfficalUP : item.comment ? item.comment.isOfficalUP : false,
            published: item.post_Date,
            liked: !!item.isLike ? item.isLike : false,
            deleted: item.isDeleted > 0,
            pollId: item.voteId,
            status: item.userStatus,
            totalReplies: 0,
            children: [],
            userKey:"",
            gid: item.gid,
        };
        return comment;
    }
}
